export default "__VITE_ASSET__fc5d2d75__"